export const PRINTABLE_CONTAINER_ID = 'printable-container';
export const APP_CONTAINER_ID = 'app-container';
